export default "__VITE_ASSET__9c0838fb__"